// extracted by mini-css-extract-plugin
export var dividerContainer = "_8w-0";
export var line = "_8w-1";